<div class="form-group">
	<div class="row">
		<div class="col-sm-3"><label for=description>{{parameterLabel}}</label></div>
		<div class="col-sm-5">
			<input class="form-control" type="text" [(ngModel)]="typeaheadValue" style="display: inline; width: 200px"
				[typeahead]="entities"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				(typeaheadOnSelect)="typeaheadOnSelect($event)"
				typeaheadOptionField="name" />
		</div>
	</div>
</div>
